import { UserInfo } from 'runtime/data/userinfo';

export class WorkItemInfo {
    workItemId: string;
    workflowInstanceId: string;
    state: string;
    arrivalDate: string;
    lastModifiedDate: string;
    dueDate: string;
    claimDate: string;
    claimUserInfo: UserInfo;
    submitDate: string;
    submitUserInfo: UserInfo;
    title: string;
    priority: number;
    keywords: string;
    attributeValue1: string;
    attributeSortValue1: string;
    attributeValue2: string;
    attributeSortValue2: string;
    attributeValue3: string;
    attributeSortValue3: string;
    attributeValue4: string;
    attributeSortValue4: string;
    attributeValue5: string;
    attributeSortValue5: string;
    attributeValue6: string;
    attributeSortValue6: string;
    attributeValue7: string;
    attributeSortValue7: string;
    attributeValue8: string;
    attributeSortValue8: string;
    attributeValue9: string;
    attributeSortValue9: string;
    attributeValue10: string;
    attributeSortValue10: string;
    stepName: string;
    stepTitle: string;
    definitionName: string;
    definitionVersion: string;
    definitionTitle: string;
    versionId: string;
    canView: boolean;
    canEdit: boolean;
    canAssign: boolean;
    canTransfer: boolean;
    canCancel: boolean;
    canForceCancel: boolean;

    // extensions
    markedForProcessing = false;
}